export default "__VITE_ASSET__89f68d2f__"